import { createStyles, Fade, Paper, Theme, Typography, WithStyles, withStyles } from '@material-ui/core'
import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import { getAllEMActivities } from '../../services/enrollment.service'
import { Activity } from '../../services/Model/Activity'
import { getSorting, Sort, stableSort } from '../../services/sortingService'
import TableWrapper, { TableItem } from '../../Tables/TableWrapper'
import DefaultLoaderModal from '../DefaultLoaderModal/DefaultLoaderModal'
import {ConnectedProps, connect} from "react-redux"
import {updateCredentialDoc, setPK, genericAction} from '../../features/pacticipantOutcomeSlice'
import { getEmployers } from '../../services/outcomes.service'


const mapStateToProps = (state:any) => ({
  credentialDoc: state.participantOutcome.credentialDoc
});

const mapDispatchToProps = { updateCredentialDoc,setPK, genericAction };

const connector = connect(
  mapStateToProps,
  mapDispatchToProps
)

type PropsFromRedux = ConnectedProps<typeof connector>

interface ActivitiesProps extends WithStyles<typeof styles>, PropsFromRedux {}
export type RouterProps = ActivitiesProps & RouteComponentProps<{}> & WithStyles<{}>

interface ActivitiesState {
	activities: TableItem[]
	loadingActivitiesList: boolean
	activitiesListOrder: Sort
	activitiesListOrderBy: string
}

const ACTIVITIES_TABLE_HEADERS = [
	{ label: 'Activity Name', prop: 'name' },
	{ label: 'Start Date', prop: 'startDate' },
	{ label: 'End Date', prop: 'endDate' },
]
const INITIAL_STATE: ActivitiesState = {
	activities: [],
	loadingActivitiesList: true,
	activitiesListOrder: 'asc',
	activitiesListOrderBy: 'name',
}

const formatActivitiesArray = (arr: Activity[]): TableItem[] => {
	const transformedActivities = arr.map((i) => {
		return {
			name: i.name,
			startDate: i.startDate,
			endDate: i.endDate,
			title: {
				label: i.name,
				url: `/activities/${i.id}`,
			},
			content: [{ isDate: true, value: i.startDate }, { isDate: true, value: i.endDate }],
		}
	})

	return transformedActivities
}

export class Activities extends React.Component<RouterProps, ActivitiesState> {
	public readonly state: ActivitiesState = INITIAL_STATE

	handleRequestSort = (currentOrder: string, sortLabel: string) => {
		const newOrder = currentOrder === 'asc' ? 'desc' : 'asc'
		const updatedSortedActivities = stableSort(this.state.activities, getSorting(newOrder, sortLabel))

		this.setState({
			activitiesListOrder: newOrder,
			activitiesListOrderBy: sortLabel,
			activities: updatedSortedActivities,
		})
	}

	setActivities = (activities: Activity[]) => {
		this.setState({
			activities: stableSort(formatActivitiesArray(activities), getSorting('asc', 'name')),
			loadingActivitiesList: false,
		})
	}

	public componentDidMount() {
    console.log(`node 22`)
    function loadDateChangeBtn(){
      const mainHeader = document.getElementById('mainHeader');

        const button = document.getElementById('dateChangeBtn');
        
        const timer = setTimeout(() => {
          if (mainHeader) {
            mainHeader.style.justifyContent = 'space-between';
          }
          if (button) {
            button.style.display = 'block';
          }
          clearTimeout(timer);
        }, 100);
    }

		getAllEMActivities()
			.then((data)=>{
        if(data.pk){
          this.props.setPK(data.pk)
        }
        if(data.siteCode){
          this.props.genericAction({siteCode:data.siteCode})
        }
        if(data.activities && data.activities.length>0){
          this.setActivities(data.activities)
        }
        loadDateChangeBtn()
      })
			.catch((e) => {
        this.setActivities([])
        loadDateChangeBtn()
      })

      getEmployers().then((employers)=>{
        debugger
        if(employers && employers.length>0){
          this.props.genericAction({ employers: [...employers] });
        }
      })
      .catch((e)=>{
        console.log(`Error in getEmployers ${e.message}`)
      })
      
	}

	render() {
		const { classes } = this.props
		const { activitiesListOrder, activitiesListOrderBy, activities, loadingActivitiesList } = this.state

		return loadingActivitiesList ? (
			<DefaultLoaderModal loading={loadingActivitiesList} />
		) : (
			<Fade in={!loadingActivitiesList} timeout={{ enter: 1000 }}>
				<Paper elevation={2} className={classes.root}>
					<Typography variant="h5" component="h2" className={classes.header}>
						Activities
					</Typography>

					<section className={classes.activitiesContainer}>
						<TableWrapper
							loading={loadingActivitiesList}
							headers={ACTIVITIES_TABLE_HEADERS}
							rowItems={activities}
							onSortClick={this.handleRequestSort}
							sortDirection={activitiesListOrder}
							orderBy={activitiesListOrderBy}
							paginationFooter={activities.length > 10}
						/>
					</section>
				</Paper>
			</Fade>
		)
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			padding: `${theme.spacing.unit}px`,
		},
		activitiesContainer: {
			display: 'flex',
			justifyContent: 'space-evenly',
			padding: `${theme.spacing.unit * 2}px 0`,
		},
		header: {
			textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
			fontWeight: 500,
		},
	})

export default connector(withStyles(styles)(Activities))
